import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PlusSVG, TrashSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { ProductContext, useProductContext } from '../../../contexts';
import { useAdaptive } from '../../../hooks';
import { getValue, parseKeyToDataTest, setValue } from '../../../utils';
import { CONTROL } from '../constants';
import { ObjectControlUi } from '../ObjectControl';
import { getDefaultValues } from '../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ArrayControlUi(_ref) {
  var accessorKey = _ref.accessorKey,
    ui = _ref.ui,
    controls = _ref.controls,
    max = _ref.max,
    addText = _ref.addText,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    invertTrashOffset = _ref.invertTrashOffset;
  var _useProductContext = useProductContext(),
    valueProp = _useProductContext.value,
    onChangeProp = _useProductContext.onChange;
  var _useAdaptive = useAdaptive(),
    isMobile = _useAdaptive.isMobile;
  var value = getValue(valueProp, accessorKey);
  var _onChange = function onChange(newValue) {
    setValue(valueProp, accessorKey, newValue);
    onChangeProp(valueProp);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [value === null || value === void 0 ? void 0 : value.map(function (_, idx) {
      return /*#__PURE__*/_jsx(ProductContext.Provider, {
        value: {
          value: _objectSpread({}, getValue(value, "[".concat(idx, "]"))),
          onChange: function onChange(newValue) {
            setValue(value, "[".concat(idx, "]"), newValue);
            _onChange(value);
          }
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.row,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.wrap,
            "data-mobile": isMobile || undefined,
            children: /*#__PURE__*/_jsx(ObjectControlUi, {
              ui: ui,
              controls: controls,
              type: CONTROL.Object
            })
          }), (value !== null && value !== void 0 ? value : []).length > min && /*#__PURE__*/_jsx(ButtonFunction, {
            icon: /*#__PURE__*/_jsx(TrashSVG, {}),
            className: invertTrashOffset ? styles.trashInvert : styles.trash,
            size: "m",
            onClick: function onClick() {
              value === null || value === void 0 ? void 0 : value.splice(idx, 1);
              _onChange(value);
            }
          })]
        }, idx)
      }, idx);
    }), (value !== null && value !== void 0 ? value : []).length < max && /*#__PURE__*/_jsx(ButtonFunction, {
      icon: /*#__PURE__*/_jsx(PlusSVG, {}),
      size: "m",
      iconPosition: "before",
      label: addText,
      onClick: function onClick() {
        _onChange((value !== null && value !== void 0 ? value : []).concat([getDefaultValues(controls)]));
      },
      "data-test-id": parseKeyToDataTest('button')
    })]
  });
}